import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LifecycleActions } from './global/actions';
import { useStateSelector, AuthenticationInfoSelector, account } from './global/dataSelectors';
import { DataFeedInitializer } from './feed/DataFeedInitializer';
import { useDispatcher } from './global/hooks';
import { QuoteRequestInitializer } from './quotes/QuoteRequestHandler';
import { AccountActions } from './global/actions/AccountActions';
import { UserRole } from '@tradingblock/types';

export const DataInitializer: React.FC<{}> = () => {
  const { isAuthenticated, apiToken, token, accountId } = useStateSelector(AuthenticationInfoSelector);
  const dispatch = useDispatch();
  const { dispatcher } = useDispatcher();
  const accountRoles = useStateSelector(account.userRoles);
  const isIRA = useStateSelector(s => s.account.isIRA);
  const isUGMA = useStateSelector(s => s.account.isUGMA);
  const isPartnership = useStateSelector(s => s.account.isPartnership);

  useEffect(() => {
    if (isAuthenticated) {
      //dispatch(Actions.requestAccounts({ id: accountId }));
      dispatch(AccountActions.loadUserData({ accountId }));
      dispatch(LifecycleActions.loadInitialData());
    }
  }, [dispatch, isAuthenticated, accountId]);
  useEffect(() => {
    if (isAuthenticated && accountId) {
      if (accountRoles !== undefined) {
        if (accountRoles.includes(UserRole.CashieringApproval) && !isIRA && !isUGMA && !isPartnership) {
          dispatcher.balances.requestPendingTransfers();
        }
      }
      // dispatcher.balances.request();
    }
  }, [dispatcher, isAuthenticated, accountRoles]);

  return (
    <>
      {apiToken && isAuthenticated && token && account && accountId && (
        <>
          <DataFeedInitializer apiToken={apiToken} authToken={token} accountId={accountId} />
          <QuoteRequestInitializer apiToken={apiToken} authToken={token} accountId={accountId} />
        </>
      )}
    </>
  );
};
